import { render, staticRenderFns } from "./InformationVariant.vue?vue&type=template&id=3eb69cc8"
import script from "./InformationVariant.vue?vue&type=script&lang=js"
export * from "./InformationVariant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports